import type { LoginRedirectSearch } from '@/lib/login-redirect-search'

type LoginSearchWithSignedOut = LoginRedirectSearch & { signed_out?: '1' }

export function rawSignedOutInBrowserUrl(
  search = typeof window !== 'undefined' ? window.location.search : '',
): boolean {
  return new URLSearchParams(search).get('signed_out') === '1'
}

export function buildSameOriginHrefWithoutSignedOut(
  to: '/' | '/cadastro',
  rest: Record<string, unknown>,
  origin = typeof window !== 'undefined'
    ? window.location.origin
    : 'http://localhost:3010',
): string {
  const path = to === '/' ? '/' : '/cadastro'
  const u = new URL(path, origin)
  for (const [k, v] of Object.entries(rest)) {
    if (v === undefined || v === null) continue
    if (typeof v === 'string' && v.length === 0) continue
    u.searchParams.set(k, String(v))
  }
  return u.toString()
}

export function stripSignedOutFromSearch(
  search: LoginSearchWithSignedOut,
): Record<string, unknown> {
  const { signed_out: _omit, ...rest } = search
  return rest
}

export function isSignedOutSearch(
  search: LoginSearchWithSignedOut,
  browserSearch?: string,
): boolean {
  return search.signed_out === '1' || rawSignedOutInBrowserUrl(browserSearch)
}
